import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface BackgroundCheckErrorBottomSheetProps {
  modalState: UseModalState;
}

export function BackgroundCheckErrorBottomSheet(props: BackgroundCheckErrorBottomSheetProps) {
  const { modalState } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter
          orientation="vertical"
          onClose={() => {
            modalState.closeModal();
          }}
        />
      }
    >
      <BottomSheetIllustrationContent
        title="Background check not approved yet"
        description="You can't work this shift as your background check is not in an approved state."
        illustrationType="document-rejected"
      />
    </BottomSheet>
  );
}
